import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Phone } from 'lucide-react';

const IsolationPage = () => {
  return (
    <div className="IsolationPage bg-white">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center py-24"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1591684080176-bb2b73f9ec68)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#2D9A68]/95 to-[#2F5BA0]/85"></div>
        <div className="relative container mx-auto px-4">
          <div className="max-w-3xl text-white">
            <p className="text-lg mb-3 font-semibold opacity-90">🏠 Confort & Économies</p>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Isolation Thermique</h1>
            <p className="text-xl md:text-2xl mb-6">Réduisez vos factures jusqu'à 30% - Le premier geste pour économiser</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="bg-[#2F5BA0] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#1e3a66] transition-all inline-flex items-center justify-center gap-2"
              >
                Nous contacter
              </Link>
              <a
                href="tel:0188617508"
                className="bg-white text-[#2D9A68] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
              >
                <Phone size={20} />
                01 88 61 75 08
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quelle isolation choisir */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Quelle isolation choisir ?</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <a 
                href="#isolation-combles" 
                className="bg-gradient-to-br from-[#2D9A68] to-[#2F5BA0] p-6 rounded-xl shadow-lg text-white hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105"
              >
                <h3 className="text-xl font-bold mb-2">🏠 Combles</h3>
                <p className="mb-3">Priorité n°1 • 30% d'économies</p>
                <p className="text-sm opacity-90">Plafond ou Rampants</p>
                <p className="text-sm opacity-90">Aides jusqu'à 3 700€</p>
              </a>
              <a 
                href="#isolation-sous-sol" 
                className="bg-white p-6 rounded-xl shadow-md border-2 border-gray-200 hover:shadow-xl hover:border-[#2D9A68] transition-all cursor-pointer transform hover:scale-105"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2">👣 Sous-Sol</h3>
                <p className="text-gray-700 mb-3">Supprime le sol froid • 10% d'économies</p>
                <p className="text-sm text-gray-600">Planchers Bas</p>
                <p className="text-sm text-gray-600">Aides jusqu'à 3 700€</p>
              </a>
              <a 
                href="#isolation-murs" 
                className="bg-white p-6 rounded-xl shadow-md border-2 border-gray-200 hover:shadow-xl hover:border-[#2D9A68] transition-all cursor-pointer transform hover:scale-105"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2">🧱 Murs Intérieurs</h3>
                <p className="text-gray-700 mb-3">Confort thermique • 20-25% d'économies</p>
                <p className="text-sm text-gray-600">Isolation par l'intérieur</p>
                <p className="text-sm text-gray-600">Aides jusqu'à 5 550€</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Pourquoi isoler */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Pourquoi isoler est prioritaire ?</h2>
            <p className="text-xl text-gray-700 mb-8">
              Avant d'installer un nouveau chauffage, isolez votre logement ! Vous réduirez vos besoins en chauffage et optimiserez votre investissement.
            </p>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gray-50 p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-[#2D9A68] mb-2">30%</div>
                <p className="text-gray-700">Économies sur la facture de chauffage</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-[#2D9A68] mb-2">25€/m²</div>
                <p className="text-gray-700">Aides MaPrimeRénov' par m²</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-[#2D9A68] mb-2">+10%</div>
                <p className="text-gray-700">Valorisation de votre bien</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ISOLATION COMBLES */}
      <section id="isolation-combles" className="py-16 bg-white scroll-mt-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Titre */}
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Isolation des Combles</h2>
              <p className="text-xl text-gray-600">Plafond ou Rampants - Jusqu'à 30% d'économies</p>
            </div>

            {/* Aides */}
            <div className="bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white rounded-2xl p-8 text-center mb-12 shadow-lg">
              <p className="text-lg mb-2 opacity-90">💰 Aides disponibles</p>
			  <p className="text-3xl md:text-4xl font-bold">Jusqu'à 3 700€ </p>
			  <p className="text-3xl md:text-4xl font-bold">Combles (CEE 12€/m²)</p>
              <p className="text-3xl md:text-4xl font-bold">Rampants (MaPrimeRénov' 25€/m² + CEE 12€/m²)</p>
            </div>

            {/* Images */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                'https://www.apc-paris.com/app/uploads/assets/w1016-we1/6722/TECHNI1.png',
                'https://www.cible-energie.fr/wp-content/uploads/2024/02/attic-insulation.png',
                'https://customer-assets.emergentagent.com/job_3ccb3377-9827-446a-8cff-ddaef1849a1d/artifacts/o9ko3z4p_image.png',
              ].map((img, index) => (
                <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-white flex items-center justify-center" style={{minHeight: '300px'}}>
                  <img 
                    src={img} 
                    alt={`Isolation Combles - ${index + 1}`}
                    className="w-full h-auto max-h-96 object-contain p-4"
                  />
                </div>
              ))}
            </div>

            {/* Qu'est-ce que */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce que l'isolation des combles ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                L'isolation des combles consiste à installer un matériau isolant entre votre espace de vie et votre toiture pour éviter que la chaleur ne s'échappe par le haut. C'est le poste de rénovation thermique le plus rentable : les combles non isolés sont responsables de 25 à 30% des déperditions de chaleur d'une maison !
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Il existe deux types d'isolation selon votre configuration :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg ml-4">
                <li><strong>Combles perdus :</strong> Non aménageables, isolation par soufflage de laine minérale sur le plancher</li>
                <li><strong>Combles aménagés ou aménageables :</strong> Isolation sous les rampants de toiture</li>
              </ul>
            </div>

            {/* Comment le mettre en place */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Comment mettre en place l'isolation des combles ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                <strong>Pour les combles perdus :</strong>
              </p>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4 text-lg ml-4">
                <li>Préparation : Nettoyage du plancher des combles, vérification de l'état de la charpente</li>
                <li>Protection : Pose de rehausses autour des conduits de cheminée et spots électriques</li>
                <li>Soufflage : Projection de laine minérale (laine de verre ou roche) sur 300-400 mm d'épaisseur</li>
                <li>Contrôle : Vérification de l'épaisseur et de la résistance thermique (R ≥ 7)</li>
              </ol>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                <strong>Pour les combles aménagés :</strong>
              </p>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4 text-lg ml-4">
                <li>Installation de suspentes et rails métalliques</li>
                <li>Pose de panneaux ou rouleaux de laine minérale entre les chevrons</li>
                <li>Installation du pare-vapeur (membrane étanche à la vapeur d'eau)</li>
                <li>Pose du parement (plaques de plâtre) pour la finition</li>
              </ol>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Durée des travaux : 1 journée pour combles perdus, 2-3 jours pour combles aménagés selon surface.
              </p>
            </div>

            {/* Avantages et Inconvénients */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">✅ Avantages</h3>
                <div className="space-y-4">
                  {[
                    '🔥 30% de réduction sur factures',
                    '💰 Aides jusqu\'à 3 700€',
                    '❄️ Confort été comme hiver',
                    '⚡ Travaux rapides (1-2 jours)',
                    '🏡 Valorisation +10%',
                    '🔇 Amélioration acoustique',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <Check className="text-[#2D9A68] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">⚠️ Inconvénients</h3>
                <div className="space-y-4">
                  {[
                    '📏 Perte hauteur sous combles',
                    '🏠 Accès combles nécessaire',
                    '🧹 Dépose ancien isolant si existant',
                    '💨 Gêne pendant travaux',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pour quels logements */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pour quel type de logement ?</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg">
                <li><strong>Toutes maisons individuelles</strong> avec combles (perdus ou aménageables)</li>
                <li><strong>Prioritaire pour maisons anciennes</strong> (construites avant 1974)</li>
                <li><strong>Combles perdus :</strong> Technique par soufflage, rapide et efficace</li>
                <li><strong>Combles aménagés :</strong> Isolation sous rampants avec finition habitable</li>
                <li>Compatible avec tous types de charpente (traditionnelle, fermettes)</li>
              </ul>
            </div>

            {/* Caractéristiques techniques */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Caractéristiques Techniques</h3>
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
                <ul className="space-y-4">
                  {[
                    'Résistance thermique : R ≥ 7 m².K/W (exigence aide maximale)',
                    'Matériaux : laine de verre, laine de roche, ouate de cellulose',
                    'Épaisseur combles perdus : 300 à 400 mm',
                    'Épaisseur combles aménagés : 200 à 300 mm',
                    'Certification ACERMI obligatoire',
                    'Pare-vapeur : membrane Sd ≥ 18 m',
                    'Durée de vie : 50 ans minimum',
                    'Garantie décennale sur pose',
                  ].map((spec, index) => (
                    <li key={index} className="flex items-start gap-3 text-lg">
                      <Check className="text-[#2F5BA0] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Séparateur */}
      <div className="border-t-4 border-gray-200"></div>

      {/* ISOLATION SOUS-SOL */}
      <section id="isolation-sous-sol" className="py-16 bg-gray-50 scroll-mt-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Titre */}
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Isolation des Planchers Bas (Sous-Sol)</h2>
              <p className="text-xl text-gray-600">Supprimez la sensation de sol froid - 10% d'économies</p>
            </div>

            {/* Aides */}
            <div className="bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white rounded-2xl p-8 text-center mb-12 shadow-lg">
              <p className="text-lg mb-2 opacity-90">💰 Aides disponibles</p>
              <p className="text-3xl md:text-4xl font-bold">Jusqu'à 3 700€ (CEE 12€/m²)</p>
            </div>

            {/* Images */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                'https://storage.canalblog.com/11/04/1425142/113698520.png',
                'https://www.plus-que-pro.shop/medias/products/2023/09/22/isolation-thermique-des-planchers-bas-en-laine-de-roche-revetu-de-film-aluminium-0-1732711506.jpg',
                'https://www.bioazur-habitat.com/images/professionnel/562070/20210415-092929.jpg',
              ].map((img, index) => (
                <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-white flex items-center justify-center" style={{minHeight: '300px'}}>
                  <img 
                    src={img} 
                    alt={`Isolation Sous-Sol - ${index + 1}`}
                    className="w-full h-auto max-h-96 object-contain p-4"
                  />
                </div>
              ))}
            </div>

            {/* Qu'est-ce que */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce que l'isolation des planchers bas ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                L'isolation des planchers bas consiste à isoler le plafond de votre cave, sous-sol ou vide sanitaire, c'est-à-dire la face inférieure de votre plancher du rez-de-chaussée. Cette technique évite que le froid remonte du sol dans votre habitation et supprime la sensation désagréable de "pieds froids" dans les pièces de vie.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Souvent négligée, l'isolation des planchers bas permet pourtant de réaliser 7 à 10% d'économies de chauffage. C'est un investissement rentable qui améliore significativement le confort thermique, notamment dans les chambres et salons du rez-de-chaussée.
              </p>
            </div>

            {/* Comment le mettre en place */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Comment mettre en place l'isolation des planchers bas ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                La technique d'isolation par le dessous présente l'avantage majeur de ne pas réduire la hauteur sous plafond de vos pièces de vie :
              </p>
              <ol className="list-decimal list-inside space-y-3 text-gray-700 mb-4 text-lg ml-4">
                <li><strong>Préparation :</strong> Nettoyage du plafond de cave, traitement anti-humidité si nécessaire</li>
                <li><strong>Fixation :</strong> Pose de rails métalliques ou collage direct selon support</li>
                <li><strong>Isolation :</strong> Installation de panneaux rigides de polystyrène expansé, polyuréthane ou laine minérale (100-150 mm)</li>
                <li><strong>Finition :</strong> Protection mécanique (plaques, grillage) selon usage de la cave</li>
              </ol>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                L'isolation est réalisée depuis votre cave ou vide sanitaire, sans aucun travail dans vos pièces de vie. Durée des travaux : 1 à 2 jours selon surface.
              </p>
            </div>

            {/* Avantages et Inconvénients */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">✅ Avantages</h3>
                <div className="space-y-4">
                  {[
                    '🔥 10% de réduction sur factures',
                    '💰 Aides jusqu\'à 3 700€',
                    '👣 Plus de pieds froids',
                    '⚡ Travaux rapides (1-2 jours)',
                    '📏 Pas de perte hauteur habitable',
                    '🔇 Amélioration acoustique',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <Check className="text-[#2D9A68] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">⚠️ Inconvénients</h3>
                <div className="space-y-4">
                  {[
                    '🏠 Nécessite cave/sous-sol accessible',
                    '📏 Hauteur minimum 1,60m requise',
                    '📉 Réduction hauteur sous cave',
                    '🔧 Traitement humidité parfois nécessaire',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pour quels logements */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pour quel type de logement ?</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg">
                <li><strong>Maisons avec cave, sous-sol ou vide sanitaire accessible</strong></li>
                <li><strong>Hauteur minimale :</strong> 1,60 m pour accès confortable</li>
                <li><strong>Idéal pour maisons sur terre-plein ou sur pilotis</strong></li>
                <li><strong>Cave non chauffée :</strong> Obligatoire pour l'efficacité</li>
                <li>Travaux réalisables même si la cave est encombrée (on travaille au plafond)</li>
              </ul>
            </div>

            {/* Caractéristiques techniques */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Caractéristiques Techniques</h3>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <ul className="space-y-4">
                  {[
                    'Résistance thermique : R ≥ 3 m².K/W minimum',
                    'Matériaux : polystyrène expansé, polyuréthane, laine minérale',
                    'Épaisseur : 100 à 150 mm selon matériau',
                    'Lambda (conductivité) : 0,022 à 0,040 W/(m.K)',
                    'Installation : collage, fixation mécanique ou rail',
                    'Finition : protection mécanique si nécessaire',
                    'Durée de vie : 50 ans minimum',
                    'Garantie décennale sur pose',
                  ].map((spec, index) => (
                    <li key={index} className="flex items-start gap-3 text-lg">
                      <Check className="text-[#2F5BA0] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Séparateur */}
      <div className="border-t-4 border-gray-200"></div>

      {/* ISOLATION MURS */}
      <section id="isolation-murs" className="py-16 bg-white scroll-mt-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Titre */}
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Isolation des Murs Intérieurs</h2>
              <p className="text-xl text-gray-600">Confort thermique et acoustique - 20-25% d'économies</p>
            </div>

            {/* Aides */}
            <div className="bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white rounded-2xl p-8 text-center mb-12 shadow-lg">
              <p className="text-lg mb-2 opacity-90">💰 Aides disponibles</p>
              <p className="text-3xl md:text-4xl font-bold">Jusqu'à 5 550€ (MaPrimeRénov' 25€/m² + CEE 18€/m²)</p>
            </div>

            {/* Images */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                'https://devis-isolation.fr/photos/isolation-thermique-des-murs-par-l-interieur.png',
                'https://prod-saint-gobain-fr.content.saint-gobain.io/sites/saint-gobain.fr/files/2024-03/isolation-mur-exterieur-la-maison-saint-gobain.jpg',
                'https://bo.laprimeenergie.fr/sites/default/files/styles/web_p/public/2022-03/isolation_des_murs_int%C3%A9rieurs.jpg.webp?itok=28yXO0pT',
              ].map((img, index) => (
                <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-white flex items-center justify-center" style={{minHeight: '300px'}}>
                  <img 
                    src={img} 
                    alt={`Isolation Murs - ${index + 1}`}
                    className="w-full h-auto max-h-96 object-contain p-4"
                  />
                </div>
              ))}
            </div>

            {/* Qu'est-ce que */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce que l'isolation des murs intérieurs ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                L'isolation des murs par l'intérieur (ITI) consiste à poser un isolant thermique sur les murs donnant sur l'extérieur, puis à le recouvrir d'un parement (généralement des plaques de plâtre). Cette technique permet de réduire de 20 à 25% les déperditions thermiques dues aux murs non isolés, tout en améliorant significativement l'isolation phonique.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                L'ITI est la solution la plus courante en rénovation car elle ne modifie pas l'aspect extérieur de votre façade et ne nécessite pas d'échafaudage ni d'autorisation d'urbanisme. C'est particulièrement adapté aux copropriétés, centres-villes historiques ou façades à conserver.
              </p>
            </div>

            {/* Comment le mettre en place */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Comment mettre en place l'isolation des murs intérieurs ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Deux techniques principales existent :
              </p>
              <p className="mb-3 text-gray-700 font-bold text-lg">Technique 1 : Doublage collé (méthode rapide)</p>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4 text-lg ml-4">
                <li>Préparation des murs : nettoyage, rebouchage des fissures</li>
                <li>Application de plots de colle sur les complexes isolants (polystyrène + plaque de plâtre)</li>
                <li>Pose et ajustement des panneaux contre les murs</li>
                <li>Traitement des joints entre panneaux</li>
              </ol>
              
              <p className="mb-3 text-gray-700 font-bold text-lg">Technique 2 : Ossature métallique (méthode performante)</p>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4 text-lg ml-4">
                <li>Fixation de rails métalliques sur murs, sol et plafond</li>
                <li>Pose de l'isolant (laine minérale) entre les montants</li>
                <li>Installation du pare-vapeur (membrane hygrorégulante)</li>
                <li>Vissage des plaques de plâtre sur l'ossature</li>
                <li>Traitement des joints et finitions (prêt à peindre)</li>
              </ol>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Durée des travaux : 2 à 5 jours selon surface. Les pièces sont traitées une par une pour minimiser la gêne.
              </p>
            </div>

            {/* Avantages et Inconvénients */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">✅ Avantages</h3>
                <div className="space-y-4">
                  {[
                    '🔥 20-25% d\'économies',
                    '💰 Aides jusqu\'à 5 550€',
                    '🏠 Pas de modification façade',
                    '🔇 Isolation phonique renforcée',
                    '🎨 Finitions impeccables',
                    '💡 Supprime paroi froide',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <Check className="text-[#2D9A68] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">⚠️ Inconvénients</h3>
                <div className="space-y-4">
                  {[
                    '📏 Perte 10-15cm par mur',
                    '🔧 Radiateurs à déplacer',
                    '🏠 Pièce inutilisable pendant travaux',
                    '⏱️ Durée 2-5 jours/pièce',
                    '💶 Coût initial plus élevé',
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pour quels logements */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pour quel type de logement ?</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg">
                <li><strong>Maisons et appartements</strong> avec murs donnant sur l'extérieur</li>
                <li><strong>Copropriétés :</strong> Pas de modification de façade (pas d'autorisation AG nécessaire)</li>
                <li><strong>Centres-villes historiques :</strong> Façades à conserver</li>
                <li><strong>Logements chauffés :</strong> L'isolation par l'intérieur nécessite un chauffage actif</li>
                <li>Note : Perte de 10-15 cm de surface habitable par mur isolé</li>
              </ul>
            </div>

            {/* Caractéristiques techniques */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Caractéristiques Techniques</h3>
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
                <ul className="space-y-4">
                  {[
                    'Résistance thermique : R ≥ 3,7 m².K/W',
                    'Épaisseur totale : 100 à 140 mm (isolant + plaque)',
                    'Matériaux : laine minérale (R=3,7), polystyrène (R=4)',
                    'Doublage : Plaque de plâtre BA13 (12,5 mm)',
                    'Pare-vapeur : Selon diagnostic hygrométrique',
                    'Perte de surface : 10-15 cm par mur',
                    'Finition : Prête à peindre (bandes et enduit)',
                    'Garantie décennale',
                  ].map((spec, index) => (
                    <li key={index} className="flex items-start gap-3 text-lg">
                      <Check className="text-[#2F5BA0] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Prêt à réduire vos factures ?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            L'isolation est le premier geste pour économiser - Nos experts Qualibat vous conseillent
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/test-eligibilite"
              className="bg-[#E6A835] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#d49520] transition-all inline-flex items-center justify-center gap-2"
            >
              Testez votre éligibilité <ArrowRight />
            </Link>
            <Link
              to="/contact"
              className="bg-white text-[#2D9A68] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
            >
              Demander un devis gratuit
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IsolationPage;
